'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';

export function CarBuying() {
  const text = 'Car buying shaped to your life'.split(' ');

  return (
    <section className='section-car-buying pt-10 md:pt-20 pb-15 md:pb-30 bg-sidebar-accent'>
      <div className='container'>
        <Image className='mx-auto animate-bounce' src='/images/common/brand.png' width={32} height={33} alt='' />
        <div
          className='text-primary-3 font-bold text-[2rem] md:text-[4rem]
          text-center mb-6 md:mb-10 whitespace-pre-line'
        >
          {text.map((el, i) => (
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 0.8,
                  delay: i / 8, // Animation duration
                },
              }}
              viewport={{ once: false }}
              key={i}
            >
              {el}{' '}
            </motion.span>
          ))}
        </div>
        <div className='flex justify-center'>
          <Link className='inline-block' href='/'>
            <Image
              className='animate-pulse'
              src='/images/logo/logo-secondary.png'
              width={196}
              height={116}
              alt=''
              quality={100}
            />
          </Link>
        </div>
      </div>
    </section>
  );
}
